import { ICustomerVehiclesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useCustomerVehicles = (customerId: string | undefined): ICustomerVehiclesHook => {
  const { customerStore } = useStore();
  const { customerVehicles, customerVehiclesLoading } = customerStore;

  useEffect(() => {
    customerId && customerStore.getCustomerVehicles(customerId);

    return () => {
      customerStore.clearCustomerVehicles();
    };
  }, [customerStore, customerId]);

  return {
    loading: customerVehiclesLoading,
    vehicles: customerVehicles,
  };
};
